import {
    useGetDMaxCommon,
    type AroundDmaxInfoResponse,
    type GuideDmaxInfoResponse,
    type MainInfoDmaxResponse,
    type RefundDmaxInfoResponse,
} from "@/shared/server";
import { Center, Spinner, Text } from "@chakra-ui/react";
import { BackBanner, GuideDetail, PieceBanner, Refund, Travel } from "../common";

export const Guide = () => {
    const { data: main } = useGetDMaxCommon<MainInfoDmaxResponse>({ section: "main" });
    const { data: guide } = useGetDMaxCommon<GuideDmaxInfoResponse>({ section: "guide" });
    const { data: around } = useGetDMaxCommon<AroundDmaxInfoResponse>({ section: "around" });
    const { data: refund } = useGetDMaxCommon<RefundDmaxInfoResponse>({ section: "refund" });
    return main && guide && around && refund ? (
        <Center flexDir="column" w="100%">
            <PieceBanner
                imgUrl={main.imgList[0].img_URL}
                title={{
                    main: "Pension Guide",
                    sub: "펜션 종합이용안내",
                }}
            />
            <GuideDetail guide={guide} />
            <Refund refunds={refund} />
            <BackBanner imgUrl={main.imgList[0].img_URL} />
            {around.isUse && <Travel around={around} />}
        </Center>
    ) : (
        <Center h="100vh" columnGap="8px">
            <Text>LOADING</Text>
            <Spinner />
        </Center>
    );
};
